import React from "react";
import { fmt } from "./needsApplicationModel";

export default function PathwayNode({ group, onInspect }) {
  return (
    <button
      type="button"
      className={`v25a-pathway-node ${group.orientation}`}
      onClick={() => onInspect(group)}
    >
      <span className="v25a-node-mark" aria-hidden="true" />
      <span className="v25a-node-copy">
        <b>{group.label}</b>
        <small>
          {group.rootCount} {group.rootCount === 1 ? "root" : "roots"} ·{" "}
          {group.pathwayCount} {group.pathwayCount === 1 ? "pathway" : "pathways"}
        </small>
      </span>
      <span className="v25a-node-warrant">
        {group.averageWarrant === null ? "—" : fmt(group.averageWarrant, 2)}
      </span>
    </button>
  );
}
